


import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import "./AboutUs.css";

import firstdate from "../images/IMG_2404.webp";
import firstadventure from "../images/IMG_6418.webp"; 
import firstadventure2 from '../images/IMG_2518.webp';
import firstadventure3 from '../images/IMG_6381.webp';
import bigmove from '../images/IMG_0459.webp';

import kitty1 from '../images/kitty1.webp';
import kitty2 from '../images/kitty2.webp';
import kitty3 from '../images/kitty3.webp';
import kitty4 from '../images/kitty4.webp';
import kitty5 from '../images/kitty5.webp';
import kitty6 from '../images/kitty6.webp';

import japan1 from '../images/japan1.webp';
import japan2 from '../images/japan2.webp';
import japan4 from '../images/japan4.webp';
import japan5 from '../images/japan5.webp';
import japan6 from '../images/japan6.webp';
import japan7 from '../images/japan7.webp';




// import image1 from "../images/image1.webp";
// import image2 from "../images/image2.webp";
// import image3 from "../images/image3.webp";
// import image4 from "../images/image4.webp";
// import image5 from "../images/image5.webp";
// import image6 from "../images/image6.webp";
import image7 from "../images/image7.webp";
import image8 from "../images/image8.webp";
import image10 from "../images/image10.webp";
// import image11 from "../images/image11.webp";
import image12 from "../images/image12.webp";
import image13 from "../images/image13.webp";
import image14 from "../images/image14.webp";


const storyEvents = [
  { date: "March 2021", title: "How We Met", description: "It all started with a swipe and a simple message on Hinge. What began as a digital connection quickly turned into something real when we met for our first date at Watts & Ward—a speakeasy bar with warm lighting, craft cocktails, and just the right amount of magic in the air. The conversation flowed, the laughter was effortless, and by the end of the night, we knew this was something special.", image: firstdate },
  { date: "May 2021", title: "Our First Adventure", description: "Our first adventure together took us on a weekend escape to Asheville, where we embraced the charm of nature and the cozy comfort of a yurt-shaped Airbnb. Nestled in the mountains, we spent our days hiking the trails that weaved through the gorgeous landscape. One evening, we camped beneath a canopy of stars. On a sunny afternoon we made our way to the French Broad River, where we sipped local beer and reveled in the tranquil beauty of the water. We even indulged in some rich, handmade chocolate, savoring the sweetness of the moment as much as the flavors. It was a weekend filled with exploration, connection, and memories that would last a lifetime.", images: [firstadventure, firstadventure3, firstadventure2] },
  { date: "2022", title: "The Big Move", description: "We took a leap of faith and officially moved in together, making our house a home. Packing boxes, mismatched furniture, and a townhome that would test the patience of saints. Moving in together wasn’t just about sharing a space—it was about building a home, learning each other’s quirks, and making even the most ordinary moments feel extraordinary.", image: bigmove },
  { date: "September 10th, 2022", title: "First pets", description: "We adopted our first pets together, a bonded pair of kittens named Ducky and Cosmo. They brought joy, laughter, and a whole lot of chaos into our lives. From midnight zoomies to snuggles on the couch, they quickly became the heart of our home. With their playful antics and unconditional love, Cosmo and Ducky showed us that family comes in all shapes and sizes.", images: [kitty5, kitty2, kitty3, kitty4, kitty1, kitty6] },
  { date: "May 2023", title: "First International Trip", description: "Two weeks in Japan, wandering through ancient temples, neon-lit streets, and quiet gardens. Springtime sakura petals floated around us as we ate our way through ramen shops, got lost in Kyoto’s alleyways, and watched the city lights dance along Tokyo’s skyline. Somewhere between the cherry blossoms and late-night train rides, he realized—this was it. This was forever.", images:[japan1, japan2, japan7, japan4, japan5, japan6]},
  { date: "December 10th, 2024", title: "The Proposal", description: "A walk to a restaurant in downtown Raleigh turned into a moment straight out of a movie. On the steps of the Capitol Building, with a storm raging around us, Cameron handed Molly a letter. As she read, he got down on one knee. The rain poured and the wind blustered, but in that moment, the world felt perfectly still. Through happy tears, laughter, and the kind of love that feels like home, Molly said 'yes'.", images: [image14, image13, image12, image10,image8, image7] },
];

export default function OurStory() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section className="our-story">
      <div className="container">
        <h2 className="title">Our Story</h2>
      </div>
      <div className="timeline">
        <div className="timeline-line"></div>
        {storyEvents.map((event, index) => (
          <motion.div 
            key={index} 
            initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
            animate={{ opacity: isVisible ? 1 : 0, x: 0 }}
            transition={{ duration: 0.6, delay: index * 0.3 }}
            className={`timeline-event ${index % 2 === 0 ? "right" : "left"}`}
          >
            <span className="date">{event.date}</span>
            <h3 className="event-title">
              {event.title} 
            </h3>
            <p className="event-description">{event.description}</p>

            {event.images ? (
              event.images.map((image, imgIndex) => (
                <img key={imgIndex} src={image} alt={`${event.title} ${imgIndex + 1}`} className="event-image" />
              ))
            ) : (
              <img src={event.image} alt={event.title} className="event-image" />
            )}
          </motion.div>
        ))}
      </div>
    </section>
  );
}
